import React from 'react';
import { useTranslation } from 'react-i18next';
import clsx from 'clsx';

import Button from '@material-ui/core/Button';
import MuiLink from '@material-ui/core/Link';
import makeStyles from '@material-ui/core/styles/makeStyles';
import { darken } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';

import {
  CONTACT,
  CORP,
  PRIVACY_POLICY,
  TERMS_OF_SERVICE,
} from '../../constants/routing';

const useStyles = makeStyles((theme) => ({
  container: {
    flexDirection: 'column-reverse',
    [theme.breakpoints.up('sm')]: {
      flexDirection: 'row',
    },
  },
  navGrid: {
    justifyContent: 'center',
    [theme.breakpoints.up('sm')]: {
      justifyContent: 'flex-start',
    },
  },
  contact: {
    backgroundColor: theme.palette.common.white,
    '&:hover': {
      backgroundColor: darken(
        theme.palette.common.white,
        theme.palette.action.hoverOpacity,
      ),
    },
  },
  business: {
    color: theme.palette.common.white,
    '&:hover': {
      color: theme.palette.common.white,
    },
  },
  buttonGroup: {
    marginLeft: 'auto',
    width: '100%',
    height: '100%',
    maxWidth: 500,
  },
  button: {
    height: '100%',
    padding: '10px 3px',
    width: '100%',
    fontSize: theme.typography.pxToRem(14),
    [theme.breakpoints.up('sm')]: {
      width: 'auto',
      minWidth: 180,
      padding: '10px 20px',
    },
  },
  buttonLabel: {
    display: 'block',
    [theme.breakpoints.only('xs')]: {
      display: 'inline-flex',
      flexDirection: 'column',
      justifyContent: 'center',
    },
  },
  link: {
    color: theme.palette.common.white,
    fontSize: theme.typography.pxToRem(14),
    textDecoration: 'none',
    '&:hover': {
      color: theme.palette.common.white,
      textDecoration: 'none',
    },
  },
}));

const LinkGridItem = ({ href, children, ...others }) => {
  const classes = useStyles();
  return (
    <Grid
      item
      component={MuiLink}
      href={href}
      className={classes.link}
      {...others}
    >
      {children}
    </Grid>
  );
};

const MapBlock = () => {
  const { t } = useTranslation();
  const classes = useStyles();
  return (
    <Grid
      container
      spacing={2}
      alignItems="stretch"
      className={classes.container}
      wrap="nowrap"
    >
      <Grid item xs={12} sm={6} style={{ margin: 'auto 0' }}>
        <Grid container spacing={2} className={classes.navGrid}>
          <LinkGridItem href={CORP}>{t('footer.corp')}</LinkGridItem>
          <LinkGridItem href={TERMS_OF_SERVICE}>
            {t('footer.terms')}
          </LinkGridItem>
          <LinkGridItem href={PRIVACY_POLICY}>
            {t('footer.privacy')}
          </LinkGridItem>
          <LinkGridItem
            href={process.env.NOTION_JOB_OPPORTUNITIES_URL}
            target="_blank"
            rel="noopener noreferrer"
          >
            {t('footer.jobOpportunities')}
          </LinkGridItem>
          <LinkGridItem
            href={process.env.ZENDESK_FAQ_URL}
            target="_blank"
            rel="noopener noreferrer"
          >
            {t('footer.faq')}
          </LinkGridItem>
        </Grid>
      </Grid>
      <Grid item xs={12} sm={6} className={classes.buttonGroup}>
        <Grid
          container
          spacing={2}
          alignItems="stretch"
          justify="flex-end"
          wrap="nowrap"
        >
          <Grid item xs={6} sm="auto">
            <Button
              href={CONTACT}
              color="primary"
              className={clsx(classes.button, classes.contact)}
              disableElevation
            >
              {t('footer.contact')}
            </Button>
          </Grid>
          <Grid item xs={6} sm="auto">
            <Button
              href={process.env.NOTION_MUNICIPALITY_URL}
              target="_blank"
              variant="contained"
              color="primary"
              disableElevation
              className={clsx(classes.button, classes.business)}
              classes={{ label: classes.buttonLabel }}
            >
              <span>{t('footer.municipality')}</span>
            </Button>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default MapBlock;
